import {
  ApiSlugs,
  ListPagination,
  ReconcileZammadTicketsResponseDto,
  TicketId,
  TicketSummaryDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class TicketsAdminConnector extends ApiConnector<TicketSummaryDto, TicketSummaryDto, TicketId> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.TICKETS);
  }

  reconcile = (hours?: number): Observable<ReconcileZammadTicketsResponseDto> =>
    this.apiCaller.postRequest<ReconcileZammadTicketsResponseDto>(this.apiPrefix, `${this.slug}/reconcile`, {
      hours,
    });

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<TicketSummaryDto[]> =>
      this.apiCaller.getRequest<TicketSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
